<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.data"
        item-key="objectId"
        :loading="isLoading || isMainLoading"
        class="border-2 dataTable row-pointer data-table-companion"
        :no-data-text="$t('customer.no_companion_customer')"
        :no-results-text="$t('no_matching_records_found')"
        :items-per-page="20"
        :options.sync="tableOptions"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50],
        }" @update:items-per-page="updateItemsPerPage" @update:page="updatePage" @update:sort-desc="updateSortBy"
        :search="search">
        <!-- :server-items-length="isKeyword ? -1 : projectCustomerCount" -->

        <template v-slot:header.fullName="{ header }">
          <div class="text-nowrap-table text-center" style="min-width:190px">{{ header.text }}</div>
        </template>
        <template v-slot:header.nickName="{ header }">
          <div class="text-nowrap-table text-center" style="min-width:190px;">{{ header.text }}</div>
        </template>
        <template v-slot:header.customerCompanions="{ header }">
          <div class="text-nowrap-table text-center" style="min-width:190px">{{ header.text }}</div>
        </template>
        <template v-slot:item.fullName="{ item }">
          <div class="text-truncate customer-name text-start">
            {{ item.fullName }}
          </div>
        </template>
        <template v-slot:item.nickName="{ item }">
          <div class="text-truncate customer-name text-start">
            {{ item.nickName }}
          </div>
        </template>
        <template v-slot:item.genderText="{ item }">
          <div class="text-truncate customer-name text-start">
            {{ item.genderText }}
          </div>
        </template>
        <template v-slot:item.tels="{ item }">
          <div
            v-for="(tel, telIndex) in item.tels"
            :key="telIndex"
          >
            {{ tel }}
          </div>
        </template>
        <template v-slot:item.customerCompanions="{ item }">
          <div class="text-truncate companion-name text-start">
            <a class="link-hover"
              v-for="(customerCompanion, index) in filterCustomerCompanions(item.customerCompanions)" :key="index"
              :href="`/project/${projectId}/market/${marketId}/customer/${customerCompanion.customer.objectId}/view?tabs=0`"
              target="_blank">{{ customerCompanion.customer.fullNameNoTitle }} ({{ $te(`account.${customerCompanion.name}`) ? $t(`account.${customerCompanion.name}`) : customerCompanion.name }}){{ index <
                filterCustomerCompanions(item.customerCompanions).length - 1 ? ', ' : '' }}</a>
          </div>
        </template>
        <template v-slot:item.view="{ item }">
          <div @click="isCompanionDialog = true; companionId = item.objectId">
            <v-btn color="primary" text>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <FormCompanion v-model="isCompanionDialog" event="edit" :companionId="companionId" :projectId="projectId"
      @onCreated="fetchData" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import FormCompanion from "./FormCompanion.vue";
export default {
  components: {
    FormCompanion
  },
  props: {
    projectId: String,
    marketId: String,
    isMainLoading: Boolean,
    isKeyword: Boolean,
    customer: Object,
    search: String,
    isDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      tableOptions: {},
      itemsPerPage: 20,
      page: 0,
      order: {},
      isCompanionDialog: false,
      companionId: ""
    };
  },
  computed: {
    ...mapState({
      companions: state => state.companion.companions
    }),
    dataTable() {
      return {
        headers: [
          {
            text: this.$t('customer.companion_code'),
            value: "companionId",
            width: "200px",
            align: "center"
          },
          {
            text: this.$t('customer.companion_name'),
            value: "fullName",
            width: "1%",
            align: "center",
            align: "start hd-resize text-truncate",
            class: "custom-sort",
          },
          {
            text: this.$t('customer.companion_customer_nickname'),
            value: "nickName",
            width: "1%",
            align: "start hd-resize text-truncate",
            class: "custom-sort",
          },
          {
            text: this.$t('customer.companion_customer_gender'),
            value: "genderText",
            width: "80px",
            align: "center"
          },
          {
            text: this.$t('customer.companion_customer_phone'),
            value: "joinTels",
            width: "150px",
            align: "center"
          },
          {
            text: this.$t('customer.companion_customer'),
            value: "customerCompanions",
            width: "1%",
            align: "start hd-resize text-truncate",
            sortable: false
          },
          { text: "", value: "view", width: "50px", sortable: false }
        ],
        data: this.companions
      };
    }
  },
  watch: {
    customer(value) {
      if (value && value.objectId) {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        if (this.customer && this.customer.objectId) {
          await this.$store.dispatch("companion/getCompanionsByCustomer", {
            projectId: this.projectId,
            limit: this.itemsPerPage,
            page: this.page,
            order: this.order,
            customerId: this.customer.objectId
          });
        } else {
          await this.$store.dispatch("companion/getCompanionsByProject", {
            projectId: this.projectId,
            limit: this.itemsPerPage,
            page: this.page,
            order: this.order
          });
        }
        this.$emit("updateData", true);
        this.isLoading = false;
      } catch (error) {
        console.log("err", error);
        this.isLoading = false;
        this.isError = true;
      }
    },
    async updateItemsPerPage() {
      if (!this.isKeyword) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
        this.itemsPerPage = itemsPerPage;
        this.page = page - 1;
        await this.fetchData(itemsPerPage, page - 1);
      }
    },
    async updatePage() {
      if (!this.isKeyword) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
        this.itemsPerPage = itemsPerPage;
        this.page = page - 1;
        await this.fetchData(itemsPerPage, page - 1);
      }
    },

    async updateSortBy() {
      if (!this.isKeyword) {
        const { sortBy, sortDesc } = this.tableOptions;
        this.order = {};
        if (sortDesc.length) {
          if (sortDesc[0]) {
            if (sortBy[0] == "fullName")
              this.order.descending = ["firstName", "lastName"];
            else this.order.descending = sortBy.map(d => d);
          } else {
            if (sortBy[0] == "fullName")
              this.order.ascending = ["firstName", "lastName"];
            else this.order.descending = sortBy.map(d => d);
          }
        }
        await this.fetchData();
      }
    },
    filterActive(contracts) {
      if (contracts && contracts.length) {
        return contracts.filter(ct => ct.isActive);
      }
      return [];
    },
    filterCustomerCompanions(customerCompanions) {
      if (customerCompanions && customerCompanions.length) {
        return customerCompanions.filter(ct => !ct.isRemoved);
      }
      return [];
    },
    joinContractAreas(areas) {
      if (areas && areas.length) {
        return areas
          .filter(ar => !ar.isRemoved)
          .map(area => area.name)
          .join(", ");
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.data-table-companion::v-deep td.hd-resize {
  max-width: 200px;
}

.data-table-companion::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 30px;
    top: 15px;
  }
}

/*
.text-start {
  border-right: 1px solid #eee;
}
*/

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  // text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  // text-align: center !important;
  padding-right: 2rem !important;
  max-width: 250px;
}

.v-data-table::v-deep tbody tr td:nth-child(5) {
  text-align: left !important;
}

.link-hover {
  color: #000000de;
}

.link-hover:hover {
  color: #47bd82;
  text-decoration: underline;
}

.row-cursor tbody tr:hover {
  cursor: pointer;
}

.text-nowrap-table.business-name,
.text-nowrap-table.customer-name,
.text-nowrap-table.companion-name {
  width: 100%;
  text-align: center;
}

.text-nowrap-table.companion-name {
  text-align: left;
}
</style>
